<app-contract-payment-form [form]="form" [validFrom]="contract.startDate"></app-contract-payment-form>
<div class="modal-footer d-flex justify-content-between">
  <p-button
    (onClick)="cancel()"
    [label]="'CONTRACT.CANCEL' | translate"
    icon="la la-times"
    iconPos="left"
    severity="danger"
  ></p-button>

  <p-button
    (click)="onSubmit()"
    [disabled]="isPending()"
    [loading]="isPending()"
    [label]="'CONTRACT.SUBMIT' | translate"
    icon="la la-check"
    iconPos="left"
    severity="primary"
  ></p-button>
</div>
